import $ from "jquery";

const user = "INC";
const pw = "INC";
const tenant = "secEnterprise";
const authToken = null;

$(() => {

  $("a").each(function() {
    const $this = $(this);
    const href = $this.attr("href");

    if (/\?.*(open-statistics-database).*/.test(href)) {
      $this.toggleClass("inc-go-to-statistics", true);
    }
  });

  $(".inc-go-to-statistics").on("click", function (event) {
    event.preventDefault();

    $.ajaxSetup({ cache: false });

    $.ajax({
      cache: false,
      url: "https://businessobjects.nutfruit.org:6443/biprws/logon/long",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({ userName: user, password: pw, auth: tenant }),

      success(data) {
        let xmlDoc;

        if (window.DOMParser) {
          const parser = new DOMParser();
          data = new XMLSerializer().serializeToString(data);
          xmlDoc = parser.parseFromString(data, "text/xml");
        } else {
          // Internet explorer
          xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
          xmlDoc.async = false;
          xmlDoc.loadXML(data);
        }

        const token = xmlDoc.getElementsByTagName("attrs")[0].firstChild.lastChild.nodeValue;
        const tokenEncoded = encodeURIComponent(token);

        window.open(
          `https://businessobjects.nutfruit.org/BOE/OpenDocument/opendoc/openDocument.jsp?sIDType=CUID&iDocID=AcBMl94oUGNJoV7lEwLeWy4&token=${tokenEncoded}`,
          "_blank"
        );

        return false;
      },
      error() {
        window.open(
          "http://www.nutfruit.org/what-we-do/industry/statistics?error=true",
          "_blank"
        );
      },
    });
  });
});
